import { C, T, type Painter, type IconName } from './paint';

/** Lightweight paper controls. Visual height is independent of the touch target. */
export const STUDIO = { surface: '#FFFEFA', muted: '#F0EDE6', line: '#E6E3DB', accent: '#267CB8', pale: '#EAF3F9', quiet: '#787F87', dark: '#263542' };
export function studioButton(p: Painter,id: string,label: string,x: number,y: number,w: number,h: number,action:()=>void,style:'primary'|'secondary'|'plain'|'orange'='plain',disabled=false,icon?:IconName) {
  const held=p.pressedId===id&&!disabled, solid=style==='primary'||style==='orange';
  const visual=Math.min(42,h-6),vy=y+(h-visual)/2;
  p.box(x,vy,w,visual,disabled?STUDIO.muted:solid?STUDIO.accent:style==='secondary'?STUDIO.pale:held?STUDIO.muted:STUDIO.surface,12,solid||disabled?undefined:STUDIO.line,0);
  if(held){p.ctx.save();p.ctx.globalAlpha=.07;p.box(x,vy,w,visual,C.ink,12);p.ctx.restore();}
  const color=disabled?'#A7AAA9':solid?C.white:style==='secondary'?STUDIO.accent:STUDIO.dark;
  if(icon){p.icon(icon,x+18,y+h/2,15,color);p.fit(label,x+32,y+h/2,w-40,T.body,color,'600');}
  else p.fit(label,x+w/2,y+h/2,w-14,T.body,color,'600','center');
  p.hits.push({id,label,x,y,w,h,disabled,action});
}
export function studioTabs(p:Painter,items:{id:string;label:string;action:()=>void}[],selected:number,x:number,y:number,w:number,h:number){
  p.box(x,y+4,w,h-8,STUDIO.muted,13);
  const cell=(w-6)/items.length;
  items.forEach((item,i)=>{
    if(i===selected)p.box(x+3+i*cell,y+7,cell,h-14,STUDIO.surface,10,undefined,3);
    p.text(item.label,x+3+(i+.5)*cell,y+h/2,T.body,i===selected?STUDIO.accent:STUDIO.quiet,i===selected?'700':'500','center');
    p.hits.push({...item,x:x+3+i*cell,y,w:cell,h});
  });
}
export function studioLink(p:Painter,id:string,label:string,x:number,y:number,w:number,h:number,action:()=>void,disabled=false){
  if(p.pressedId===id&&!disabled)p.box(x,y+5,w,h-10,STUDIO.muted,9);
  p.fit(label,x+w/2,y+h/2,w-8,T.sub,disabled?'#BAC0C3':STUDIO.accent,'600','center');
  p.hits.push({id,label,x,y,w,h,disabled,action});
}
export function studioArrow(p:Painter,id:string,x:number,y:number,h:number,direction:-1|1,action:()=>void,disabled=false){
  if(p.pressedId===id&&!disabled)p.box(x,y+5,h,h-10,STUDIO.muted,10);
  const cx=x+h/2,cy=y+h/2;p.line([[cx-direction*3,cy-5],[cx+direction*2,cy],[cx-direction*3,cy+5]],disabled?'#C9CCCB':STUDIO.dark,1.8);
  p.hits.push({id,label:direction===-1?'上一页':'下一页',x,y,w:h,h,disabled,action});
}
